import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X, Linkedin, Download } from "lucide-react";
import { nav, social } from "../mock";
import { useBrochure } from "./BrochureProvider";
import SearchBar from "./SearchBar";
import Logo from "./Logo";
import { useEnquiry } from "./EnquiryProvider";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const brochure = useBrochure();
  const enquiry = useEnquiry();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (item) => {
    setOpen(false);
    if (item.isRoute) {
      navigate(item.href);
    } else if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.querySelector(item.href)?.scrollIntoView({ behavior: "smooth" }), 220);
    } else {
      document.querySelector(item.href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#111c4e]/95 backdrop-blur-md shadow-lg py-3" : "bg-gradient-to-b from-[#0d1640]/70 to-transparent py-4"
      }`}
    >
      <div className="kse-container flex items-center justify-between gap-4">
        <button onClick={() => go({ href: "#home" })} className="text-left shrink-0">
          <Logo />
        </button>

        <nav className="hidden xl:flex items-center gap-7">
          {nav.map((item) => (
            <button key={item.label} onClick={() => go(item)} className="text-white/90 hover:text-white text-[15px] font-medium relative group">
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-blue-300 transition-all duration-300 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden lg:block"><SearchBar variant="desktop" /></div>
          <a href={social.linkedin} target="_blank" rel="noopener noreferrer" className="hidden md:flex text-white/80 hover:text-white transition-colors" aria-label="LinkedIn">
            <Linkedin size={19} />
          </a>
          <button onClick={() => brochure?.openBrochure()} className="hidden lg:flex text-white/80 hover:text-white transition-colors" aria-label="Download brochure" title="Download brochure">
            <Download size={19} />
          </button>
          <button onClick={() => enquiry?.openEnquiry()} className="hidden sm:flex kse-btn kse-btn--accent min-h-[40px] px-4 text-sm">
            Start an enquiry
          </button>
          <button className="xl:hidden text-white" onClick={() => setOpen(!open)}>
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="xl:hidden bg-[#111c4e] border-t border-white/10 mt-3">
          <div className="kse-container py-4 flex flex-col gap-1">
            <div className="mb-3"><SearchBar variant="mobile" /></div>
            {nav.map((item) => (
              <button key={item.label} onClick={() => go(item)} className="text-left text-white/90 hover:text-white py-3 border-b border-white/5 font-medium">
                {item.label}
              </button>
            ))}
            <button onClick={() => { setOpen(false); enquiry?.openEnquiry(); }} className="kse-btn kse-btn--accent mt-4 justify-center">
              Start a manufacturing enquiry
            </button>
            <button onClick={() => { setOpen(false); brochure?.openBrochure(); }} className="kse-btn bg-white/10 text-white mt-2 justify-center text-sm">
              <Download size={16} /> Download brochure
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
